import { IServices } from "@netent/origin";
import { IGameRulesState } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const gameRulesState: FeatureStateCreator<IGameRulesState> = (
  services: IServices
): IGameRulesState => {
  if (!services.gameRules.isEnabled()) {
    return null;
  }
  return {
    content: services.gameRules.getContent()
  };
};
